<ng-container *ngFor="let view of views">
    <i class="{{getClassString(view)}} mx-1" role="button" (click)="onClick(view)" tooltip="{{getCB(view) | localize | async}}" [class.activeView]="view == currentView"></i>
</ng-container>
